// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { I18n } from '@calendly/i18n'
import { PageHeader } from '@calendly/ui/components/page-header'
import { TitleText } from '@calendly/ui/components/typography'

import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context'

export const NewHeader = () => {
  const inSettingsModal = useIsSettingsModalLayout()

  if (inSettingsModal) {
    return null
  }

  return (
    <PageHeader
      title={I18n.t('publisher.admin.billing.title')}
      eyebrow={(
        <TitleText variant="eyebrow">
          {I18n.t('publisher.admin.navigation.organization')}
        </TitleText>
      )}
    />
  )
}
